
import Footer from "@/app/ui/components/footer/index.vue";
import { PHONE_NUMBER_HD } from "@/app/infrastructures/misc/Utils";
import { cleanPhoneNumber } from "@/app/infrastructures/misc/common-library/Whatsapp";
import { computed, defineComponent, onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import { AccountController } from "../../controllers/AccountController";

export default defineComponent({
  name: "LoginDeviceLimit",
  components: { Footer },

  setup() {
    const router = useRouter();

    const hasEmail = computed(() => AccountController.accountData.email);
    const whatsappNumberRedirect = computed(() =>
      cleanPhoneNumber(PHONE_NUMBER_HD)
    );
    const whatsappNumber = computed(() => PHONE_NUMBER_HD);

    onMounted(() => {
      if (!hasEmail.value) router.replace("/");
    });

    onUnmounted(() => {
      AccountController.setAccountEmail("");
    });

    return {
      hasEmail,
      whatsappNumber,
      whatsappNumberRedirect
    };
  }
});
